import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { resetScrollPosition } from '../utils/scrollUtils';

/**
 * Custom hook to reset scroll position on route changes
 * Scrolls to top when navigating to a new page
 * @param {Object} options - Configuration options
 * @param {boolean} options.resetOnPathChange - Whether to reset scroll on path change (default: true)
 * @param {number} options.delay - Delay in ms before scroll reset (default: 0)
 */
export const useScrollReset = (options = {}) => {
    const { resetOnPathChange = true, delay = 0 } = options;
    const location = useLocation();
    const previousPathname = useRef(location.pathname);

    useEffect(() => {
        if (!resetOnPathChange || previousPathname.current === location.pathname) {
            return;
        }

        const resetScroll = () => {
            resetScrollPosition({ smooth: false });
        };

        if (delay > 0) {
            const timeoutId = setTimeout(resetScroll, delay);
            return () => clearTimeout(timeoutId);
        } else {
            resetScroll();
        }

        // Update previous pathname
        previousPathname.current = location.pathname;
        
    }, [location.pathname, resetOnPathChange, delay]);
};